// 组件类
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { CommonFunctionService } from "../service/common-function.service";
import { DialogService } from "../service/dialog.service";
import { Debounce } from "../utils/decorator";
import { MessageGroup } from "./constants";
import { getTranslation } from "../utils/utils";

@Component({
  selector: "rs-commentary",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class RsCommentaryComponent implements OnInit {
  constructor(
    public cf: CommonFunctionService,
    private dialog: DialogService,
    private ref: ChangeDetectorRef
  ) {}

  @Input() displayName: string;
  @Input() commentData: MessageGroup[] = [];
  @Input() editPermission = true; // edit权限
  @Input() deletePermission = true; // delete权限
  @Input() isReadOnly = false;
  @Input() filedsKey = {
    commentaries: "commentaries",
    messageId: "messageId",
    ownerName: "ownerName",
    lastModifiedOn: "lastModifiedOn",
    messageBody: "messageBody",
  };
  @Input() dateTimePipeFormat = "dd-MMM-yyyy hh:mm:a";

  @Output()
  actionComplete = new EventEmitter<{
    action: "addComment" | "updateComment" | "deleteComment" | "replyComment";
    data: any;
    callback: (result: { messageId: string }) => void;
  }>();

  commentVal = "";
  replyVal = "";
  editCommentVal = "";
  translation;
  ngOnInit() {
    this.getInfo();
  }

  getInfo() {
    this.translation = getTranslation();
  }

  @Debounce(300)
  addComment() {
    this.actionComplete.emit({
      action: "addComment",
      data: { inputValue: this.commentVal },
      callback: (res) => {
        this.commentData.unshift({
          [`${this.filedsKey["messageId"]}`]: res.messageId,
          [`${this.filedsKey["commentaries"]}`]: [],
          [`${this.filedsKey["ownerName"]}`]: this.displayName,
          [`${this.filedsKey["lastModifiedOn"]}`]: Date.now(),
          [`${this.filedsKey["messageBody"]}`]: this.commentVal,
        });
        this.commentVal = "";
      },
    });
  }

  editComment(item) {
    this.editCommentVal = item[this.filedsKey["messageBody"]];
    item.showCommentEdit = true;
  }
  async updateComment(item) {
    this.actionComplete.emit({
      action: "updateComment",
      data: { ...item, inputValue: this.editCommentVal },
      callback: (res) => {
        item[this.filedsKey["messageBody"]] = this.editCommentVal;
        item.showCommentEdit = false;
        this.ref.markForCheck();
      },
    });
  }

  @Debounce(300)
  deleteComment(item) {
    const dialogRef = this.dialog.showCommonDilaog({
      title: this.translation["DELETE_COMMENT"],
      description: this.translation["DELETE_COMMENT_CONFIRM"],
      saveBtnLabel: this.translation.DELETE,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res === "close") {
        return;
      }
      const idx = this.commentData.findIndex(
        (ele) =>
          ele[this.filedsKey.messageId] === item[this.filedsKey.messageId]
      );

      this.actionComplete.emit({
        action: "deleteComment",
        data: item,
        callback: (res) => {
          this.commentData.splice(idx, 1);
          this.ref.detectChanges();
          this.ref.markForCheck();
        },
      });
    });
  }
  @Debounce(300)
  addReply(item) {
    this.actionComplete.emit({
      action: "replyComment",
      data: { ...item, inputValue: this.replyVal },
      callback: (res) => {
        item[this.filedsKey["commentaries"]].unshift({
          [`${this.filedsKey["messageId"]}`]: res[this.filedsKey["messageId"]],
          [`${this.filedsKey["commentaries"]}`]: [],
          [`${this.filedsKey["ownerName"]}`]: this.displayName,
          [`${this.filedsKey["lastModifiedOn"]}`]: Date.now(),
          [`${this.filedsKey["messageBody"]}`]: this.replyVal,
        });
        this.replyVal = "";
        item.showReplyInput = false;
        this.ref.detectChanges();
        this.ref.markForCheck();
      },
    });
  }

  @Debounce(100)
  adjustTextareaHeight(e) {
    const textarea = e.target;
    if (e.type === "focus" && textarea.value) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    } else if (e.type === "input") {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }
}
